import { render, staticRenderFns } from "./pickupType.vue?vue&type=template&id=8f7c9bf4&"
import script from "./pickupType.vue?vue&type=script&lang=js&"
export * from "./pickupType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports